﻿window.cBuilderEmailWidgetVideo = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetvideo'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Vidéo</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un lien sur une vidéo (YouTube ou hébergé par nos soins)")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetvideo'>")
        $("<!-- DEBUT VIDEO -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto' widthpercent='30'>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("video")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget'>").appendTo($Td)
        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:35%' class='tdleft'></td>").appendTo($TrTableBt)
        var $Td = $("<td style='width:30%' class='tdcenter'></td>").appendTo($TrTableBt)
        var $A = $("<a href='https://' target='_blank' />").appendTo($Td)
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablebt'>").appendTo($A)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='word-break:break-word;width:100%;'></td>").appendTo($Tr)
        var $img = $("<img src='" + imgPictureDefault + "' alt='Vidéo' style='width:100%;height:auto;opacity:0.2;' width='0' img_default='1'>").appendTo($Td)

        var $Td = $("<td style='width:35%' class='tdright'></td>").appendTo($TrTableBt)
        $("<!-- FIN VIDEO -->").appendTo(option.element)
    }

    function mGetLink() { return $(option.element.find("a")[0]) }
    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }
    function mGetTdCenter() { return $(option.element.find(".tdcenter")[0]) }
    function mGetTdRight() { return $(option.element.find(".tdright")[0]) }
    function mGetImage() { return $(option.element.find("img")[0]) }

    this.nom = "Vidéo"
    this.icone = "fas fa-circle-play"
    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
        $("<br/>").appendTo(contentElement)

        var $DivImage = $("<div style='padding:0 10px;text-align:center;'/>").appendTo(contentElement)
        var $Img = $("<img src='' style='width:100%;max-width:250px;display:inline-block;'/>").appendTo($DivImage)
        $Img.attr("src", mGetImage().attr("src"))
        $Img.on("click", function (e) { dxBt.performClick(); })
        if (typeof mGetImage().attr("img_default") != "undefined" && mGetImage().attr("img_default") != "0") $Img.css("opacity", "0.2")

        var $Div = $("<div style='text-align:center;'/>").appendTo(contentElement)
        var $Table = $("<table style='display:inline-block;'/>").appendTo($Div)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Coller",
            focusStateEnabled: false,
            onClick: function (e) {
                if (!navigator.clipboard || !navigator.clipboard.read) {
                    mNotify("Permission refusée pour accéder au presse-papiers.", "error", 6000);
                    return;
                }
                // Lit le contenu du presse-papiers
                navigator.clipboard.read().then(function (clipboardItems) {
                    clipboardItems.forEach(function (item) {
                        // Vérifie si l'élément est une image
                        if (item.types.includes('image/png')) {
                            item.getType('image/png').then(function (blob) {
                                // Convertit le Blob en Base64
                                const reader = new FileReader();
                                reader.onloadend = function () {
                                    $Img.attr("src", reader.result)
                                    $Img.css("opacity", "1")
                                    mGetImage().attr("src", reader.result)
                                    mGetImage().attr("img_default", "0")
                                    mGetImage().css("opacity", 1)
                                    $TdModif.show()
                                    $TdDel.show()
                                    option.onValueChanged()
                                };
                                reader.readAsDataURL(blob);
                            }).catch(function (error) {
                                mNotify("Erreur lors de la récupération du type de l'élément :" + error, "error", 6000);
                            });
                        } else {
                            mNotify("Aucune image dans le presse-papier.", "warning", 6000);
                        }
                    });
                }).catch(function (error) {
                    mNotify("Erreur lors de la lecture du presse-papiers :" + error, "error", 6000);
                });
            }
        }).dxCtrlButton("instance");

        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        var dxBt = $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
            html: "Choisir une image<br/>pour la vidéo",
            width: 180,
            onClick: function (e) {
                var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                    bddCtrl: option.bddCtrl,
                    icone: true,
                    imgPexel: true,
                    docCpt: false,
                    courrier: false,
                    multiple: false,
                    accept: ".png,.jpg,.jpeg,.gif,.bmp",
                    onValide: function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            var url = lstUrlFile[0]
                            $("<div/>").appendTo("body").dxCtrlPopupResizeImage({
                                bddCtrl: option.bddCtrl,
                                value: url,
                                onValidation: function (url) {
                                    $Img.attr("src", url)
                                    $Img.css("opacity", "1")
                                    mGetImage().attr("src", url)
                                    mGetImage().attr("img_default", "0")
                                    mGetImage().css("opacity", 1)
                                    $TdModif.show()
                                    $TdDel.show()
                                    option.onValueChanged()
                                }
                            })
                            //option.bddCtrl.mAjaxCall({
                            //    command: "migrein72dpiforemail",
                            //    urlimage: 
                            //}, function (data) {
                            //    $Img.attr("src", lstUrlFile[0])
                            //    $Img.css("opacity", "1")
                            //    mGetImage().attr("src", lstUrlFile[0])
                            //    mGetImage().attr("img_default", "0")
                            //    mGetImage().css("opacity", 1)
                            //    $TdModif.show()
                            //    $TdDel.show()
                            //    option.onValueChanged()
                            //})
                        }
                        pop.hide();
                    },
                    optionImgInternet: {
                        bddCtrl: option.bddCtrl
                    },
                    optionFileUploader: {
                        bddCtrl: option.bddCtrl
                    }
                }).dxCtrlFileUploaderPopup("instance")
            }
        }).dxCtrlButton("instance")
        //image saisie//on modifie
        $TdRefresh = $("<td style='width:0px;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdRefresh).dxCtrlButton({
            icon: "fas fa-refresh",
            hint: "Recalculer l'image sur la base de la vidéo",
            onClick: function (e) {
                mCalculImage(dxSaisieLink.mGetCurrentLink())
            }
        })
        $TdModif = $("<td style='width:0px;display:none;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdModif).dxCtrlButton({
            icon: "fas fa-pen",
            hint: "Modifier l'image",
            onClick: function (e) {
                var url = mGetImage().attr("src")
                if (url.startsWith("~")) url = url.substring(1)
                $("<div style='height:100%;width:100%'/>").appendTo("body").dxCtrlPopupImgEdit({
                    bddCtrl: option.bddCtrl,
                    value: url + "?d=" + (new Date()).getTime(),
                    readonly: false,
                    onConfirmModif: false,
                    onClose: function (data) {
                        if (data.contains("?")) data = data.split("?")[0]
                        $Img.attr("src", data)
                        mGetImage().attr("src", data)
                        mGetImage().attr("img_default", "0")
                        $TdModif.show()
                        $TdDel.show()
                        option.onValueChanged()

                        //$Img.attr("src", data.split("?")[0] + "?d=" + (new Date()).getTime())
                        //mGetImage().attr("src", data.split("?")[0] + "?d=" + (new Date()).getTime())
                        //$TdModif.show()
                        //$TdDel.show()
                        //option.onValueChanged()
                    }
                });
            }
        })
        $TdDel = $("<td style='width:0px;display:none;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdDel).dxCtrlButton({
            icon: "fas fa-trash",
            hint: "Supprimer l'image",
            onClick: function (e) {
                mGetImage().css("opacity", "0.2")
                $Img.css("opacity", "0.2")
                $Img.attr("src", imgPictureDefault)
                mGetImage().attr("src", imgPictureDefault)
                mGetImage().attr("img_default", "1")
                $TdModif.hide()
                $TdDel.hide()
                option.onValueChanged()
            }
        })
        if (mGetImage().attr("img_default") != "0") {
            $TdModif.hide()
            $TdDel.hide()
        } else {
            $TdModif.show()
            $TdDel.show()
        }

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Lien:</div>").appendTo(contentElement)
        var dxSaisieLink = $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailSaisieLink({
            bddCtrl: option.bddCtrl,
            dataSource: ["Aucun", "Web"], //, "Fichier"],
            value: mGetLink().attr("href"),
            title: mGetLink().attr("title") || "",
            label: "Lien web sur la vidéo",
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            lstfileheberge: option.dxBuilderEmailPage.option("lstfileheberge"),
            onValueChanged: function (link) {
                if (link.typeLink == "Aucun") {
                    mGetLink().css("pointer-events", "none")
                    option.onValueChanged()
                } else {
                    mCalculImage(link)
                    mGetLink().attr("href", link.link)
                    mGetLink().attr("title", (link.title ? link.title : ""))
                }
            }
        }).dxCtrlBuilderEmailSaisieLink("instance")
        if (typeof mGetLink().attr("isok") != 'undefined' && mGetLink().attr("isok") == "0" && mGetLink().attr("href") != "https://") { dxSaisieLink.$DivError.show() }
        else { dxSaisieLink.$DivError.hide() }

        function mCalculImage(link) {
            mGetLink().attr("href", link.link)
            switch (link.typeLink) {
                case "Aucun":
                    dxSaisieLink.$DivError.hide()
                    mGetLink().css("pointer-events", "none")
                    option.onValueChanged()
                    break;
                default:
                    if (link.link == null || link.link.length == 0) {
                        $Img.css("opacity", "0.2")
                        $Img.attr("src", imgPictureDefault)
                        mGetImage().css("opacity", "0.2")
                        mGetImage().attr("src", imgPictureDefault)
                        mGetImage().attr("img_default", "1")
                        mGetLink().attr("href", "http://")
                        mGetLink().css({
                            "cursor": "default",
                            "color": "inherit",
                            "text-decoration": "inherit",
                            "pointer-events": "none"
                        })
                        if (typeof mGetLink().attr("isok") != 'undefined' && mGetLink().attr("isok") == "0") { dxSaisieLink.$DivError.show() }
                        else { dxSaisieLink.$DivError.hide() }
                        $TdModif.hide()
                        $TdDel.hide()
                        option.onValueChanged()
                    } else {
                        jauge.mShow()
                        option.bddCtrl.mAjaxCall({
                            command: "geturlimagevideo",
                            url: link.link,
                            id_com_email_envoi_ou_id_fichier: option.dxBuilderEmailPage.mGetIdComEmailEnvoiOuIdFichier()
                        }, function (data) {
                            if (typeof data.urlimagevideo == 'undefined' || data.urlimagevideo.length == 0) {
                                $Img.css("opacity", "0.2")
                                $Img.attr("src", imgPictureDefault)
                                mGetImage().css("opacity", "0.2")
                                mGetImage().attr("src", imgPictureDefault)
                                mGetImage().attr("img_default", "1")
                                //mGetLink().attr("href", "http://")
                                //mGetLink().css({
                                //    "cursor": "default",
                                //    "color": "inherit",
                                //    "text-decoration": "inherit"
                                //})
                                $TdModif.hide()
                                $TdDel.hide()
                            } else {
                                $Img.css("opacity", "1")
                                $Img.attr("src", data.urlimagevideo)
                                mGetImage().css("opacity", "1")
                                mGetImage().attr("src", data.urlimagevideo)
                                mGetImage().attr("img_default", "0")
                                $TdModif.show()
                                $TdDel.show()
                            }
                            mGetLink().attr("isok", data.urlOk)
                            if (typeof mGetLink().attr("isok") != 'undefined' && mGetLink().attr("isok") == "0") { dxSaisieLink.$DivError.show() }
                            else { dxSaisieLink.$DivError.hide() }
                            option.onValueChanged()
                        }, function () { jauge.mHide() })
                        mGetLink().attr("href", link.link)
                        mGetLink().css({
                            "cursor": "pointer",
                            "color": "",
                            "text-decoration": ""
                        })
                    }
                    break;
            }
        }

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Texte de remplacement:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Décrivez la vidéo...",
            value: mGetImage().attr("alt"),
            onValueChanged: function (e) {
                mGetImage().attr("alt", ((e.value == null) ? "" : e.value))
                option.onValueChanged()
            }
        })
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("video")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Largeur de l'image:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleLargeur({
            allowDefaut: true,
            value: jsonCssData.width.toString().replace("%", ""),
            onValueChanged: function (value) {
                jsonCssDataOriginalValue.width = value + ((value.length == 0) ? "" : "%")
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Coins arrondis de l'image:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleRadius({
            allowDefaut: option.allowDefaut,
            radiusTopRight: jsonCssData["border-top-right-radius"],
            radiusTopLeft: jsonCssData["border-top-left-radius"],
            radiusBottomRight: jsonCssData["border-bottom-right-radius"],
            radiusBottomLeft: jsonCssData["border-bottom-left-radius"],
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    jsonCssDataOriginalValue[value.prop] = value.value
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("image")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("video")) {
            if (prop == "width") {
                var widthPercent = 0
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    widthPercent = jsonCssData[prop].replace("%", "")
                } else {
                    widthPercent = option.dxBuilderEmailPage.mJsonCssGuideProperty("image", prop).replace("%", "")
                }
                var rest = 100 - parseInt(widthPercent)

                var restWidthPx = option.parent.mGetTotalWidthContainerWithoutPaddingBorder()
                var widthPx = Math.floor(restWidthPx * parseInt(widthPercent) / 100)
                mGetImage().attr("width", widthPx)

                mGetTdCenter().attr("width", widthPercent + "%")
                mGetTdCenter().css("width", widthPercent + "%")
                switch (option.parent.mGetTextAlignCss()) {
                    case "left":
                        mGetTdLeft().attr("width", "0")
                        mGetTdLeft().css("width", "0px")
                        mGetTdRight().attr("width", rest + "%")
                        mGetTdRight().css("width", rest + "%")
                        break;
                    case "center":
                        var restDiv2 = rest / 2
                        mGetTdLeft().attr("width", restDiv2 + "%")
                        mGetTdLeft().css("width", restDiv2 + "%")
                        mGetTdRight().attr("width", restDiv2 + "%")
                        mGetTdRight().css("width", restDiv2 + "%")
                        break;
                    case "right":
                        mGetTdLeft().attr("width", rest + "%")
                        mGetTdLeft().css("width", rest + "%")
                        mGetTdRight().attr("width", "0")
                        mGetTdRight().css("width", "0px")
                        break;
                }
            } else if (prop.startsWith("border-")) {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetImage().css(prop, jsonCssData[prop])
                } else {
                    mGetImage().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("image", prop))
                }
            } else {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetTdCenter().css(prop, jsonCssData[prop])
                } else {
                    mGetTdCenter().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("video", prop))
                }
            }
        }
    }

    var imgPictureDefault = "data:image/png;base64,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"

}